import { paramsForServer } from 'feathers-hooks-common';
import client from './feathers';

const rethrowViaSetState = (component, err) => {
  // Functional components pass undefined `this` — avoid "Cannot read properties of undefined (reading 'setState')"
  if (typeof component?.setState !== 'function') {
    throw err;
  }
  return new Promise((resolve) => {
    component.setState(
      () => {
        throw err;
      },
      () => resolve(),
    );
  });
};

export const get = async (component, service, id, throwError = false) => {
  const feathersParams = paramsForServer({ url: window.location.href });
  return client
    .service(service)
    .get(id, feathersParams)
    .catch((err) => {
      if (throwError) {
        throw err;
      } else {
        return rethrowViaSetState(component, err);
      }
    });
};

export const find = async (component, service, params, throwError = false) => {
  const feathersParams = paramsForServer({
    url: window.location.href,
    ...params,
  });
  return client
    .service(service)
    .find(feathersParams)
    .catch((err) => {
      if (throwError) {
        throw err;
      } else {
        return rethrowViaSetState(component, err);
      }
    });
};

export const create = async (component, service, newInstance, throwError = false) => {
  const feathersParams = paramsForServer({ url: window.location.href });
  return client
    .service(service)
    .create(newInstance, feathersParams)
    .catch((err) => {
      if (throwError) {
        throw err;
      } else {
        return rethrowViaSetState(component, err);
      }
    });
};

// Pre-existing 5-arg signatures; wrapping would churn every call site.
// eslint-disable-next-line max-params -- matches get/find/create/remove
export const patch = async (component, service, id, data, throwError = false) => {
  const feathersParams = paramsForServer({ url: window.location.href });
  return client
    .service(service)
    .patch(id, data, feathersParams)
    .catch((err) => {
      if (throwError) {
        throw err;
      } else {
        return rethrowViaSetState(component, err);
      }
    });
};

// eslint-disable-next-line max-params -- matches get/find/create/remove
export const patchMultiple = async (component, service, params, data, throwError = false) => {
  const feathersParams = paramsForServer({
    url: window.location.href,
    ...params,
  });
  return client
    .service(service)
    .patch(null, data, feathersParams)
    .catch((err) => {
      if (throwError) {
        throw err;
      } else {
        return rethrowViaSetState(component, err);
      }
    });
};

export const remove = async (component, service, id, throwError = false) => {
  const feathersParams = paramsForServer({ url: window.location.href });
  return client
    .service(service)
    .remove(id, feathersParams)
    .catch((err) => {
      if (throwError) {
        throw err;
      } else {
        return rethrowViaSetState(component, err);
      }
    });
};

export const removeMultiple = async (component, service, params, throwError = false) => {
  const feathersParams = paramsForServer({
    url: window.location.href,
    ...params,
  });
  return client
    .service(service)
    .remove(null, feathersParams)
    .catch((err) => {
      if (throwError) {
        throw err;
      } else {
        return rethrowViaSetState(component, err);
      }
    });
};
